export type GridScope = 'catalyx' | 'client' | 'tier';

export const ROLES_SUBTAB_CAPS = {
  createCatalyx: 'admin_panel_create_catalyx_role',
  createClient: 'admin_panel_create_client_role',
  catalyx: 'admin_panel_set_capabilities_catalyx',
  client: 'admin_panel_set_capabilities_client',
  tier: 'admin_panel_set_capabilities_tier',
} as const;

export interface GridColumn {
  id: number;
  key: string | null;
  name: string;
}

export interface GridCapability {
  id: number;
  key: string;
  name: string;
  description: string;
  is_visible: boolean;
}

export interface CapabilityGridData {
  scope: GridScope;
  column_label: string;
  default_allowed: boolean;
  can_view_hidden: boolean;
  columns: GridColumn[];
  capabilities: GridCapability[];
  grants: Record<string, Record<string, boolean>>;
}

export interface GridChange {
  capability_id: number;
  column_id: number;
  is_allowed: boolean;
}

export function roleKeyFromName(name: string) {
  return name.trim().toLowerCase().split(/\s+/).filter(Boolean).join('-');
}
